export default {
  currentLatLng: null,
  centerMap: true,
  currentVideoIndex: 0,
  currentVideoTime: 0,
  fetchingPlaylist: false,
  linestrings: [],
  noPlaylistFound: false,
  playlist: [],
  step: 50
}
